import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f933634"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-grid" }
const _hoisted_2 = { class: "range-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-separator" }, "至", -1))
const _hoisted_4 = { class: "range-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "range-separator" }, "-", -1))
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "list-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_table_head = _resolveComponent("table-head")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_TableBody = _resolveComponent("TableBody")!
  const _component_ui_page = _resolveComponent("ui-page")!
  const _component_ui_container = _resolveComponent("ui-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_ui_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            class: "search-box",
            "label-width": "100px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_form_item, { label: "下单时间" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.condition.startTime,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.condition.startTime) = $event)),
                        type: "datetime",
                        placeholder: "开始日期"
                      }, null, 8, ["modelValue"]),
                      _hoisted_3,
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.condition.endTime,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.condition.endTime) = $event)),
                        type: "datetime",
                        placeholder: "结束日期"
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "关键字" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      modelValue: _ctx.condition.keyword,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.condition.keyword) = $event)),
                      placeholder: "输入订单编号、商品名称"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "价格" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.condition.priceMin,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.condition.priceMin) = $event))
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _hoisted_5,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.condition.priceMax,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.condition.priceMax) = $event))
                      }, {
                        append: _withCtx(() => [
                          _createTextVNode("元")
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "用户" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "请选择",
                      modelValue: _ctx.condition.userId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.condition.userId) = $event)),
                      remote: "",
                      clearable: "",
                      filterable: "",
                      loading: _ctx.userLoading,
                      "remote-method": _ctx.searchUser
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mesureList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading", "remote-method"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, { label: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.find()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("筛选")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, { onClick: _ctx.exportData }, {
                      default: _withCtx(() => [
                        _createTextVNode("导出")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_link, {
                      type: "primary",
                      style: {"margin":"0 0 0 10px"},
                      onClick: _ctx.resetFilter,
                      underline: false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置筛选条件")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ui_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.condition.type,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => {_ctx.condition.type = $event; _ctx.find()}),
            type: "card",
            class: "tabbar-box"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tablist, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: item.name,
                  name: item.value,
                  key: index
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_table_head),
            (!_ctx.source.loading && !_ctx.source.list.length)
              ? (_openBlock(), _createBlock(_component_el_empty, {
                  key: 0,
                  description: "暂无订单"
                }))
              : _withDirectives((_openBlock(), _createBlock(_component_TableBody, {
                  key: 1,
                  onRefresh: _ctx.refresh,
                  data: _ctx.source.list
                }, null, 8, ["onRefresh", "data"])), [
                  [_directive_loading, _ctx.source.loading]
                ])
          ]),
          _createVNode(_component_ui_page, {
            modelValue: _ctx.page.page,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.page.page) = $event)),
            info: _ctx.pageInfo
          }, null, 8, ["modelValue", "info"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}